import fontListSource from "../../docs/fonts.txt" with { type: "text" };

let cachedFamilies: string[] | undefined;

export function fontCatalogFamilies(): string[] {
  if (!cachedFamilies) {
    const families = fontListSource
      .split(/\r?\n/)
      .map(line => line.trim())
      .filter(Boolean);
    cachedFamilies = [...new Set(families)].sort((left, right) => left.localeCompare(right));
  }
  return cachedFamilies;
}

export function filterFontCatalogFamilies(query: string): string[] {
  const normalized = query.trim().toLowerCase();
  const families = fontCatalogFamilies();
  if (!normalized) {
    return families;
  }
  return families.filter(family => family.toLowerCase().includes(normalized));
}
